import { BANK_REGISTRY } from '@axo/config/banks/bank-registry';
import { BANK_NAMES as REFERENCE_NAMES } from '@axo/data-access/reference/bank-names';

const DK_NAMES: Record<string, string> = Object.fromEntries(
  BANK_REGISTRY.filter(
    (bank) => bank.markets.includes('dk') && bank.logoKey !== ''
  ).map((bank) => [`DK|${bank.logoKey}`, bank.name])
);

/**
 * Bank code → full bank name, keyed by `MARKET|CODE`: the display name a bank
 * logo's `alt` text uses (MV-3806). NO, SE and FI come from the reference data
 * in `@axo/data-access/reference/bank-names`; DK from `BANK_REGISTRY`.
 */
export const BANK_NAMES: Readonly<Record<string, string>> = {
  ...REFERENCE_NAMES,
  ...DK_NAMES,
};

/**
 * The full name of a bank by market and code, or `undefined` when unknown.
 * The country is case-insensitive; a logo variant's `-alt` suffix is ignored.
 */
export const bankName = (country: string, code: string): string | undefined =>
  BANK_NAMES[`${country.toUpperCase()}|${code.replace(/-alt$/, '')}`];
